
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppButton } from '@/components';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { GameMatchOptions, GameMatchCostState } from '@/modules/game/match/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_GAME.MATCH.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppButton },
    setup() {
        const { list, total, fetchList, variantOptions, query, actions } = useGameMatchList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: GameMatchOptions.GameMatchType },
                {
                    type: TableColumnType.Html,
                    label: 'Costs with visibility',
                    htmlHandler: (row: any) =>
                        GameMatchCostState.previewCostStates(row.costs, row.costStates)
                            .map(x => {
                                const isHidden = x.label === GameMatchCostState.STATES.Hidden.label;
                                const stateClass = isHidden ? 'text-muted' : 'font-weight-bold';
                                return `<span>${x.cost}: <span class="${stateClass}">${x.label}</span></span>`;
                            })
                            .join('<br>')
                },
                { type: TableColumnType.Text, label: 'Max round', key: 'maxRound' },
                { type: TableColumnType.Text, label: 'Max point', key: 'maxPoint' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_GAME.MATCH.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, variantOptions, query, ROUTE_NAME_GAME };
    }
});
